import React from 'react'
import DawidFoto from '../../images/DawidFoto3.png'
// import DawidFoto2 from '../../images/DawidFoto2.jpeg'
import onas1 from '../../images/onas1.png'

import css from './ONasFirst.module.css'

const ONasFirst = () => {
	return (
		<section className={css.aboutSection}>
			<div className={css.aboutTitleWrapper}>
				<h2 className={css.aboutTitle}>KILKA SŁÓW O MNIE</h2>
			</div>
			<div className={css.aboutBackground}>
				<h3 className={css.aboutSubTitle}>DAWID LEWKO</h3>
				<div className={css.aboutContainer}>
					<img className={css.aboutImgFoto} src={DawidFoto} alt='about' />
					<div>
						<p className={css.aboutText}>
							Witam! Nazywam się <b>Dawid Lewko</b> i jestem psychologiem.
							Urodziłem się z niepełnosprawnością wzrokową, dlatego możesz czuć
							się tutaj swobodnie — na pewno nie ocenię Cię po wyglądzie.
							Moim celem jest <b>stworzenie bezpiecznej przestrzeni</b>, w której będziesz
							mógł otwarcie mówić o swoich trudnościach.
							<br /> <br />
							Posiadam doświadczenie w pracy z <b>osobami zmagającymi</b> się z lękiem oraz trudnościami
							w nawiązywaniu i utrzymywaniu relacji. W swojej pracy łączę różne <b>podejścia terapeutyczne</b>,
							aby jak najlepiej dostosować pomoc do Twoich potrzeb. Wykorzystuję między innymi
							psychoedukację, pracę nad emocjami oraz techniki relaksacyjne, takie jak medytacja.
							Dzięki temu mogę zaoferować Ci wsparcie zarówno w radzeniu sobie ze stresem,
							jak i w budowaniu pewności siebie oraz poprawie jakości życia.
						</p>
					</div>
				</div>
				<div className={css.aboutContainer}>
					{/*<img className={css.aboutImgFoto} src={DawidFoto2} alt='about' />*/}
					<div>
						<p className={css.aboutText}>
							Moje doświadczenia życiowe sprawiły, że miałem okazję przebywać w bardzo
							różnorodnych środowiskach. Dzięki temu potrafię spojrzeć na problemy z
							wielu perspektyw i lepiej zrozumieć wyzwania, przed którymi stoisz.
							Wierzę, że empatia oraz umiejętność słuchania są kluczowe w pracy psychologa,
							dlatego podczas naszych spotkań możesz liczyć na pełne zrozumienie i akceptację.
							<br /> <br />
							Jeśli potrzebujesz wsparcia lub chcesz porozmawiać o swoich trudnościach,
							serdecznie zapraszam na konsultację. Razem możemy pracować nad rozwiązaniami,
							które pomogą Ci odzyskać równowagę i lepiej radzić sobie z wyzwaniami dnia codziennego.
						</p>
					</div>
				</div>
				<div className={css.textContainer}>
					<p className={css.aboutText}>
						<b>Do zobaczenia!</b>
						<br />
						<br />
						<b>Dawid Lewko — psycholog</b>
					</p>
					<img className={css.aboutImg} src={onas1} alt='about' />
				</div>
			</div>
		</section>
	)
}

export default ONasFirst
